



































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import StreakPopup from 'frontend/components/header/StreakPopup.vue';
import Button from 'frontend/components/Button.vue';
import { StreakCalendarDay, StreakNotificationType } from 'frontend/types';

@Component({
  components: { Button, StreakPopup },
})
export default class StreakButton extends Vue {
  @Prop(Number) private readonly currentStreak!: number;
  @Prop(Number) private readonly problemsSolvedInCurrentStreak!: number;
  @Prop(Boolean) private readonly isMobile!: boolean;
  @Prop(String) private readonly notificationType!: StreakNotificationType;
  @Prop(Boolean) private readonly popupVisible!: boolean;
  @Prop(Array) private readonly calendarDays!: StreakCalendarDay[];
  @Prop(Number) private readonly problemsRequiredPerDay!: number;
  @Prop(Boolean) private readonly canIncreaseStreak!: boolean;
  @Prop(Number) private readonly maxNumStreakCharges!: number;
  @Prop(Number) private readonly numAvailableStreakCharges!: number;

  @Watch('popupVisible')
  visibilityChanged(): void {
    if (this.popupVisible) {
      window.addEventListener('click', this.clickedOutsideListener);
    } else {
      window.removeEventListener('click', this.clickedOutsideListener);
    }
  }

  private clickedOutsideListener(event: MouseEvent) {
    const streakModalElement = document.getElementById('streak-popup');
    const clickedOutside = !streakModalElement?.contains(event.target as Node);

    if (clickedOutside) {
      this.$emit('should-close');
    }
  }

  private get completedTodaysStreak(): boolean {
    return !this.canIncreaseStreak;
  }
}
